module.exports = __webpack_public_path__ + "img/29.d87c0b6c.jpg";